<span
  class="inspection-name"
  #headerName
  [attr.contenteditable]="editMode"
  (click)="enterEditMode()"
  (blur)="leaveEditMode(headerName.textContent)"
  (keydown)="nameChanged($event)"
  >{{ header }}
</span>
